var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"exhibitor-inner-two",attrs:{"id":"app"}},[_c('div',{staticClass:"container-row"},[_c('div',{staticClass:"heading-row heading-row-v4"}),_c('ExhibitorList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }